module.exports = __webpack_public_path__ + "static/wsa-15e6a41c272bbb1efb178cea0617ed4c.png";